<template>
  <div class='main-wrapper'>
        <form @submit.prevent='submitForm' v-if='submitted === false'>
           <div class='card-background'>
               <div class="card-content">
                   <v-card-text>
                <!-- Name Input Field -->
                <v-text-field
                    ref="name"
                    dark
                    v-model.trim="name"
                    @blur='$v.name.$touch'
                    label="Full Name"
                ></v-text-field>
                <span v-if='!$v.name.required && $v.name.$dirty' class='error-message'> Name is required</span>
                
                <v-text-field
                    ref="email"
                    dark
                    v-model="email"
                    @blur='$v.email.$touch'
                    label="Email Address"
                ></v-text-field>
                <span v-if='(!$v.email.required || !$v.email.email) && $v.email.$dirty' class='error-message'> A valid email address is required</span>

                <v-text-field
                    ref="companyname"
                    dark
                    v-model.trim="companyname"
                    @blur='$v.companyname.$touch'
                    label="Company Name"
                ></v-text-field>
                <span v-if='!$v.companyname.required && $v.companyname.$dirty' class='error-message'> Company Name is required</span>

                <v-text-field
                    ref="address"
                    dark
                    v-model="address"
                    @blur='$v.address.$touch'
                    label="Address Line"
                    counter='35'
                ></v-text-field>
                <span v-if='(!$v.address.required) && $v.address.$dirty' class='error-message'> Please enter your address</span>
                <span v-if='(!$v.address.maxLength) && $v.address.$dirty' class='error-message'> Address is too long</span>

                <v-text-field
                    ref="city"
                    dark
                    v-model="city"
                    @blur='$v.city.$touch'
                    label="City"
                ></v-text-field>
                <span v-if='(!$v.city.required) && $v.city.$dirty' class='error-message'> Please enter a city name </span>
                <span v-if='(!$v.city.maxLength) && $v.city.$dirty' class='error-message'>Enter a valid city name</span>

                 <v-text-field
                     dark
                    ref="state"
                    v-model="state"
                    @blur='$v.state.$touch'
                    label="State/Province/Region"
                ></v-text-field>
                <span v-if='!$v.state.required && $v.state.$dirty' class='error-message'> Please enter a State/Province/Region </span>
                <span v-if='!$v.state.maxLength && $v.state.$dirty' class='error-message'> Enter a valid State / Province / Region </span>

                 <v-text-field
                    ref="zip"
                    dark
                    v-model="zip"
                    @blur='$v.zip.$touch'
                    label="Zip/Postal Code"
                ></v-text-field>
                <span v-if='!$v.zip.required && $v.zip.$dirty' class='error-message'> Please enter a zip/postal code </span>
                <span v-if='!$v.zip.maxLength && $v.zip.$dirty' class='error-message'> Enter a valid zip/postal code </span>
                <span v-if='!$v.zip.minLength && $v.zip.$dirty' class='error-message'> Enter a valid zip/postal code </span>
                <span v-if='!$v.zip.integer && $v.zip.$dirty' class='error-message'> Enter a valid zip/postal code </span>

                <v-autocomplete
                    ref="country"
                    dark
                    v-model="country"
                    :rules="[() => !!country || 'This field is required']"
                    :items="countries"
                    label="Country"
                    placeholder="Select..."
                    required
                ></v-autocomplete>

                <v-text-field
                    ref="resale"
                    dark
                    v-model="resale"
                    @blur='$v.resale.$touch'
                    label="Resale Tax Number"
                ></v-text-field>
                <span v-if='!$v.resale.required && $v.resale.$dirty' class='error-message'> Please enter resale tax number </span>
                <span v-if='!$v.resale.maxLength && $v.resale.$dirty' class='error-message'> Please enter resale tax number  </span>
                <span v-if='!$v.resale.minLength && $v.resale.$dirty' class='error-message'> Please enter resale tax number  </span>
                <span v-if='!$v.resale.integer && $v.resale.$dirty' class='error-message'> Must be numberic </span>
            
            <v-select
          :items="items"
          label="Type of business"
          v-model='businesstype'
          dark
          required
        ></v-select>


        </v-card-text>
        <div class='button-div'> <v-btn
          color="primary"
          type='submit'
        >
          Submit
        </v-btn></div>
            
               </div>
           </div>

    </form>
            <span class='text-h5 text' v-if='submitted'> We will get back to you shortly in regards to your application.</span>
  </div>
</template>


<script>
    
    import {required, minLength, maxLength, alpha, email, integer} from 'vuelidate/lib/validators'
    export default {
        name: 'VueForm',
        data: () => ({
            countries: ['Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola', 'Anguilla', 'Antigua &amp; Barbuda', 'Argentina', 'Armenia', 'Aruba', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bermuda', 'Bhutan', 'Bolivia', 'Bosnia &amp; Herzegovina', 'Botswana', 'Brazil', 'British Virgin Islands', 'Brunei', 'Bulgaria', 'Burkina Faso', 'Burundi', 'Cambodia', 'Cameroon', 'Cape Verde', 'Cayman Islands', 'Chad', 'Chile', 'China', 'Colombia', 'Congo', 'Cook Islands', 'Costa Rica', 'Cote D Ivoire', 'Croatia', 'Cruise Ship', 'Cuba', 'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Estonia', 'Ethiopia', 'Falkland Islands', 'Faroe Islands', 'Fiji', 'Finland', 'France', 'French Polynesia', 'French West Indies', 'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Gibraltar', 'Greece', 'Greenland', 'Grenada', 'Guam', 'Guatemala', 'Guernsey', 'Guinea', 'Guinea Bissau', 'Guyana', 'Haiti', 'Honduras', 'Hong Kong', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran', 'Iraq', 'Ireland', 'Isle of Man', 'Israel', 'Italy', 'Jamaica', 'Japan', 'Jersey', 'Jordan', 'Kazakhstan', 'Kenya', 'Kuwait', 'Kyrgyz Republic', 'Laos', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Macau', 'Macedonia', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Mauritania', 'Mauritius', 'Mexico', 'Moldova', 'Monaco', 'Mongolia', 'Montenegro', 'Montserrat', 'Morocco', 'Mozambique', 'Namibia', 'Nepal', 'Netherlands', 'Netherlands Antilles', 'New Caledonia', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'Norway', 'Oman', 'Pakistan', 'Palestine', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Poland', 'Portugal', 'Puerto Rico', 'Qatar', 'Reunion', 'Romania', 'Russia', 'Rwanda', 'Saint Pierre &amp; Miquelon', 'Samoa', 'San Marino', 'Satellite', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles', 'Sierra Leone', 'Singapore', 'Slovakia', 'Slovenia', 'South Africa', 'South Korea', 'Spain', 'Sri Lanka', 'St Kitts &amp; Nevis', 'St Lucia', 'St Vincent', 'St. Lucia', 'Sudan', 'Suriname', 'Swaziland', 'Sweden', 'Switzerland', 'Syria', 'Taiwan', 'Tajikistan', 'Tanzania', 'Thailand', `Timor L'Este`, 'Togo', 'Tonga', 'Trinidad &amp; Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Turks &amp; Caicos', 'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States', 'Uruguay', 'Uzbekistan', 'Venezuela', 'Vietnam', 'Virgin Islands (US)', 'Yemen', 'Zambia', 'Zimbabwe'],
            errorMessages: '',
            name: '',
            email: '',
            address: '',
            city:'',
            state: '',
            zip: '',
            companyname: '',
            resale: '',
            country: null,
            businesstype: null,
            formHasErrors: false,
            items: ['Retail','Wholesale'],
            submitted: false,
        }),
        validations: {
            name: {
                required,
                
            },
            email: {
                required,
                email
            },
            address: {
                required,
                maxLength: maxLength(35),
            },
            city: {
                required,
                maxLength: maxLength(25),
            },
            state: {
                required,
                maxLength: maxLength(35),
            },
            zip: {
                required, 
                maxLength: maxLength(9),
                minLength: minLength(3),
                integer
            },
            companyname: {
                required,
            },
            resale: {
                required, 
                maxLength: maxLength(35),
                minLength: minLength(5),
                integer
            }
        },

        computed: {
        form () {
            return {
                name: this.name,
                address: this.address,
                email: this.email,
                city: this.city,
                state: this.state,
                zip: this.zip,
                country: this.country,
                companyname: this.companyname,
                resale: this.resale,
                businesstype: this.businesstype
            }
        },
        },

        watch: {
        name () {
            this.errorMessages = ''
        },
        },

        methods: {
            submitForm() {
                this.$v.$touch();

                if(!this.$v.$invalid) {
                    this.sendEmail()
                    console.log('Form Submission Sucessful!')
                    this.submitted = true;
                }
            },

            async sendEmail() {
                let newRegistration = {
                    name: this.name,
                    address: this.address,
                    email: this.email,
                    city: this.city,
                    state: this.state,
                    zip: this.zip,
                    country: this.country,
                    companyname: this.companyname,
                    resale: this.resale,
                    businesstype: this.businesstype
                }

                 await fetch('https://lnuatf736k.execute-api.us-east-1.amazonaws.com/RegistrationApplication',{
                    method: "post",
                    headers: {
                        "Content-Type":"application/json",
                    },
                    body: JSON.stringify(newRegistration)
                })
            },

        addressCheck () {
            this.errorMessages = this.address && !this.name
            ? `Hey! I'm required`
            : ''
            return true
        },
        resetForm () {
            this.errorMessages = []
            this.formHasErrors = false

            Object.keys(this.form).forEach(f => {
            this.$refs[f].reset()
            })
        },
        submit () {
            this.formHasErrors = false

            Object.keys(this.form).forEach(f => {
            if (!this.form[f]) this.formHasErrors = true

            this.$refs[f].validate(true)
            })
        },
        },
    }
</script>

<style scoped>
    .main-wrapper{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        border: 0px solid;
    }
    form {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
    }
    .card {
        margin-bottom: 5vh;
        margin-top: clamp(2vh, 5vh, 7vh);
        
    }
    .card-background {
        width: clamp(80%,85%,100%);
        background-color: rgba(255,255,255,0.2);
        border-radius: 30px;
        border: 1px solid rgba(255,255,255,0.3);
        backdrop-filter: blur(40px);
        -webkit-backdrop-filter: blur(5px);
        display: flex;
        align-items: center;
        justify-content: center;
        
    }

    .card-content {
        width: 90%;
    }

    .button-div {
        
        display:flex;
        justify-content: center;
        margin-bottom: 3vh;
        
    }

    .text-field {
        color: white;
    }


    .error-message {
        color: rgba(253, 61, 61, 1);
    }

    .text {
        color: white;
    }
</style>